import React, { FC, useContext } from 'react';

import FlexColumn from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import BackAndNextNav from '@ui/molecules/BackAndNextNav';
import SpacedGridItem from '@ui/molecules/SpacedGridItem';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowBailoutStepProps } from '@folx-types/flow-steps';

export interface ISsnDlExceptionStepPageContent {
	pageHeader: string;
	pageBody: string;
}

interface ISsnDlExceptionStepProps extends IFlowBailoutStepProps {
	pageContent: ISsnDlExceptionStepPageContent;
}

const SsnDlExceptionStep: FC<ISsnDlExceptionStepProps> = ({ pageContent, stepKey }) => {
	const { pageHeader, pageBody } = pageContent;

	const { handleNavBack, handleNavNext } = useContext(FlowContext);

	return (
		<SpacedGridItem marginBottom="lgxl">
			<FlexColumn gap="sm">
				<HeadingText>{pageHeader}</HeadingText>
				<WYSIWYGContent dangerouslySetInnerHTML={{ __html: pageBody }} />
			</FlexColumn>
			<BackAndNextNav
				marginTop="xxl"
				submitLabel="Next"
				backOnClick={() => handleNavBack(stepKey)}
				nextOnClick={() => handleNavNext(stepKey)}
			/>
		</SpacedGridItem>
	);
};

export default SsnDlExceptionStep;
